import React from 'react';
import styled from 'styled-components';
import { breakpoint } from '../../../styling/mixins/breakpoints';
import { getColor } from '../../../styling/mixins/colors';
import CheckoutSectionHeader from './Checkout.SectionHeader';
import { primaryColorMap } from '../../../styling/variables/colors';

interface CheckoutSectionProps {
  children?: any;
  className?: string;
  headerClassName?: string;
  headingClassName?: string;
  title?: string;
  titleRight?: JSX.Element | string;
  hidePaddingInMobile?: boolean;
}

const StyledCheckoutSection = styled.div`
  background-color: ${getColor('white')};
  border-radius: 4px;
  padding: 2.4rem 1.6rem;

  .payment-widget-comment, .payment-widget-zip-container, .payment-widget-news {
    max-width: 640px;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    padding-bottom: 0.9rem;
    margin: 0 auto;
  }

  .payment-widget-news {
    display: flex;
    margin-top: 0.8rem;
  }

  .payment-widget-news label {
    padding: 2rem;
    background-color: ${getColor('primary')};
    border-radius: 2px;
  }

  .payment-widget-news span {
    color: ${getColor('white')}
  }

  .payment-widget-zip-container {
    margin-top: 2.4rem;
    margin-bottom: 2.4rem;
  }

  .b2CZipCode {
    margin-bottom: 1.6rem;
  }

  ${breakpoint('large')} {
    padding: 2.4rem;
  }

  .confirm-order-checkbox {
    display: block;
  } 
`;

const CheckoutSection = ({
  children,
  className = '',
  title,
  titleRight,
  headerClassName,
  headingClassName,
  hidePaddingInMobile,
}: CheckoutSectionProps) => {
  return (
    <StyledCheckoutSection className={`${className}`.trim()}>
      {title && (
        <CheckoutSectionHeader className={headerClassName}>
          <h4 className={headingClassName}>{title}</h4>
          {titleRight}
        </CheckoutSectionHeader>
      )}
      {children}
    </StyledCheckoutSection>
  );
};

export default CheckoutSection;
